import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/modules/shared/shared.module';
import { TypeCPVClassComponent } from './typeCPVClass/typeCPV-class.component';
import { TypeLieuComponent } from './typeLieu/type-lieu.component';
import { TypeObjCPVComponent } from './typeObjCPV/type-objCPV.component';
import { RectificatifComponent } from './rectificatif/rectificatif.component';
import { TypeVoieComponent } from './typeVoie/type-voie.component';
import { TypeDescMarcheComponent } from './typeDescMarche/type-desc-marche.component';
import { TypeInfosRectifComponent } from './typeInfosRectif/type-infos-rectif.component';
import { AvisInitialTypeComponent } from './avisInitialType/avis-initial-type.component';
import { ProcedureComponent } from './procedure/procedure.component';
import { TypeTravauxComponent } from './typeTravaux/type-travaux.component';
import { TypeFournituresComponent } from './typeFournitures/type-fournitures.component';
import { FormMAPA_REComponent } from './formmapa/form.mapa.re.component';
import { Step1Component } from './steps/step1/step1.component';
import { Step3Component } from './steps/step3/step3.component';
import { Step4Component } from './steps/step4/step4.component';
import { FormmapaCommonModule } from '../common/formmapa.module';

@NgModule({
  declarations: [

    TypeCPVClassComponent,
    TypeLieuComponent,
    TypeObjCPVComponent,
    RectificatifComponent,
    TypeVoieComponent,
    TypeDescMarcheComponent,
    TypeInfosRectifComponent,
    AvisInitialTypeComponent,
    ProcedureComponent,
    TypeTravauxComponent,
    TypeFournituresComponent,
    FormMAPA_REComponent,
    Step1Component,
    Step3Component,
    Step4Component],
  exports: [
    FormMAPA_REComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule, SharedModule, FormmapaCommonModule
  ]
})
export class FormmapaRectificatifModule {
}

